import { useNavigate } from 'react-router-dom';
import { Post } from '../../types/types';
import { LINKS } from '../../constants/links';

interface BlogSectionProps {
  posts: Post[];
}

const BlogSection: React.FC<BlogSectionProps> = ({ posts }) => {
  const navigate = useNavigate();

  const handlePostClick = (postId: string) => {
    navigate(`${LINKS.BLOG}#${postId}`);
  };

  const handleBlogClick = () => {
    navigate(LINKS.BLOG);
  };

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div>
      <h2
        className="text-4xl text-center font-extrabold tracking-tight mb-10 cursor-pointer hover:text-blue-600 transition duration-300"
        style={{ textDecoration: 'underline' }}
        onClick={handleBlogClick}
      >
        Blog
      </h2>
      <div className="max-w-4xl mx-auto px-4">
        <div className="space-y-4 text-center">
          {posts.map((post, index) => (
            <div
              key={index}
              className="p-4 border-b border-gray-200 dark:border-gray-700"
            >
              <h3 className="text-xl font-semibold">
                <button
                  onClick={() => handlePostClick(post.id)}
                  className="hover:text-blue-600 transition duration-300"
                >
                  {post.title}
                </button>
              </h3>
              {post.date && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                  {formatDate(post.date)}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
